import { render, staticRenderFns } from "./DeviceFilterAndDetailsReviews.vue?vue&type=template&id=15e6508f&"
import script from "./DeviceFilterAndDetailsReviews.vue?vue&type=script&lang=js&"
export * from "./DeviceFilterAndDetailsReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e6508f')) {
      api.createRecord('15e6508f', component.options)
    } else {
      api.reload('15e6508f', component.options)
    }
    module.hot.accept("./DeviceFilterAndDetailsReviews.vue?vue&type=template&id=15e6508f&", function () {
      api.rerender('15e6508f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/DeviceFilterAndDetailsReviews.vue"
export default component.exports